import React, { useState, useEffect } from "react";
import { useLocation, useHistory } from "react-router-dom";
import { useTranslation } from "../../i18n/TranslationProvider";
import { toLegacyLanguage } from "../../i18n/translateData";

import OnboardingStepHeader from "./OnboardingStepHeader";
import Sallie from "../Sallie";
import SubmitButton from "../StyledComponents/SubmitButton";
import LoadingSpinner from "../LoadingSpinner";

import {
  checkEmailToken,
  sendConfirmEmail,
  deleteEmailToken,
} from "../../api/helpReq";


const EmailConfirm = ({ setOnboardingPercent, user }) => {
  const location = useLocation();
  const history = useHistory();
  const { t, language } = useTranslation();

  useEffect(() => {
    if (!user) {
      history.push("/");
      return;
    }
  }, [user, history]);

  const url = new URLSearchParams(location.search);
  const token = url.get("token");

  const [submitting, setSubmitting] = useState(false);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  const reSendEmail = () => {
    const { firstName, lastName, email } = user;
    sendConfirmEmail({
      email: email,
      name: firstName + " " + lastName,
      // Backend still expects "english"/"spanish" until the language-code migration
      language: toLegacyLanguage(language),
    });
    history.push("/Verification/EmailSent");
  };

  const clickHandler = async () => {
    try {
      setSubmitting(true);
      deleteEmailToken();
      history.push("/");
    } catch (err) {
      setSubmitting(false);
      history.push("/oops");
    }
  };

  useEffect(() => {
    setOnboardingPercent(90);

    checkEmailToken({ token: token })
      .then((res) => {
        if (res.status !== 200) {
          setError(true);
        }
        setLoading(false);
      })
      .catch((e) => {
        console.log("token is not matched", e);
        setError(true);
        setLoading(false);
      });
  }, []);

  const sallieMsg = error 
    ? t("onboarding.emailConfirm.errorMessage") 
    : t("onboarding.emailConfirm.successMessage");

  return (
    <>
      <OnboardingStepHeader text={t("onboarding.emailConfirm.header")} />
      {loading ? (
        <LoadingSpinner />
      ) : error ? (
        <>
          <Sallie text={sallieMsg} sad="true" />
          <SubmitButton disabled={submitting} onClick={reSendEmail}>
            {t("onboarding.emailConfirm.resendButton")}
          </SubmitButton>
        </>
      ) : (
        <>
          <Sallie text={sallieMsg} />
          <SubmitButton disabled={submitting} onClick={clickHandler}>
            {t("onboarding.emailConfirm.dashboardButton")}
          </SubmitButton>
        </>
      )}
    </>
  );
};

export default EmailConfirm;